import { Text, Link, Box, Tooltip, useColorModeValue } from '@chakra-ui/react';
import { useState } from 'react';

const ReadMoreCell = ({ email, text, maxChars = 30 }) => {
  const [expanded, setExpanded] = useState(false);
  const textColor = useColorModeValue('gray.700', 'white');
  const tooltipBg = useColorModeValue('rgba(255, 255, 255, 0.95)', 'gray.700');
  const tooltipBorder = useColorModeValue('rgba(0,0,0,0.06)', 'whiteAlpha.200');
  const tooltipText = useColorModeValue('gray.700', 'white');

  if (!text) return '—';

  const isLong = text.length > maxChars;

  return (
    <Tooltip
      hasArrow
      placement="top-start"
      openDelay={250}
      bg="transparent"
      p="0"
      label={
        <Box
          px="4"
          py="3"
          maxW="340px"
          bg={tooltipBg}
          backdropFilter="blur(12px)"
          borderRadius="lg"
          boxShadow="0 20px 40px rgba(0,0,0,0.12)"
          border="1px solid"
          borderColor={tooltipBorder}
          transform="translateY(4px)"
          transition="all 0.25s ease"
          _groupHover={{
            transform: 'translateY(0px)',
            opacity: 1,
          }}
        >
          <Text
            textTransform={email ? 'none' : 'capitalize'}
            fontSize="sm"
            color={tooltipText}
            lineHeight="1.6"
          >
            {text}
          </Text>
        </Box>
      }
    >
      <Text
        textTransform={email ? 'none' : 'capitalize'}
        fontSize="16px"
        color={textColor}
        transition="all 0.2s ease"
      >
        {expanded || !isLong ? text : `${text.slice(0, maxChars)}...`}

        {isLong && (
          <Link
            ml="1"
            fontSize="xs"
            color="blue.500"
            fontWeight="600"
            onClick={(e) => {
              e.stopPropagation();
              setExpanded(!expanded);
            }}
          >
            {expanded ? 'Read less' : 'Read more'}
          </Link>
        )}
      </Text>
    </Tooltip>
  );
};

export default ReadMoreCell;
